var map = {
  "./cs.json": [
    "Zoa",
    [
      "rk"
    ]
  ],
  "./en.json": [
    "W1",
    [
      "w1h"
    ]
  ],
  "./pl.json": [
    "OkJ",
    [
      "0m"
    ]
  ],
  "./ru.json": [
    "QK",
    [
      "ie3"
    ]
  ],
  "./tr.json": [
    "fUX",
    [
      "l4"
    ]
  ],
  "./ja.json": [
    "MU",
    [
      "u43"
    ]
  ],
  "./zh.json": [
    "DW",
    [
      "5c"
    ]
  ],
  "./pt-br.json": [
    "Tz",
    [
      572
    ]
  ],
  "./de.json": [
    "ptC",
    [
      "r4"
    ]
  ],
  "./es.json": [
    "IVU",
    [
      "eg"
    ]
  ],
  "./fr.json": [
    "uH",
    [
      "c5"
    ]
  ],
  "./it.json": [
    "BQa",
    [
      "fh"
    ]
  ],
  "./ko.json": [
    "EJS",
    [
      "qc2"
    ]
  ],
  "./pt.json": [
    "CsC",
    [
      "8v"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "HL";
module.exports = __rspack_async_context;
